import { useFormikContext } from "formik";
import React, { useCallback, useEffect, useState } from "react";

import { Forms, Grid } from "components";
import { signup } from "services";

import { formatToPhone } from "brazilian-values";
import { useDebounce } from "hooks/debounce";
import { BrokerValues } from ".";
import { useSignup } from "../../store";

const Statuses = [
  "fetching-person-details",
  "fetched-person-details",
  "",
] as const;

export type BrokerResponsibleStatuses = (typeof Statuses)[number];

export const Responsible = () => {
  const { getValues } = useSignup();
  const { errors, setFieldValue } = useFormikContext<BrokerValues>();

  const [status, setStatus] = useState<BrokerResponsibleStatuses>("");

  const [_document, setDocument] = useState("");
  const document = useDebounce(_document);

  const handlePersonDetails = useCallback(async () => {
    try {
      setStatus("fetching-person-details");

      const { name, phone } = await signup.findPersonByDocument(document);

      setFieldValue("responsible.name", name);
      setFieldValue("responsible.phone", formatToPhone(phone));
    } finally {
      setStatus("fetched-person-details");
    }
  }, [document]);

  useEffect(() => {
    setStatus("");
    if (document && !errors?.responsible?.cpf) handlePersonDetails();
  }, [document, handlePersonDetails]);

  useEffect(() => {
    if (getValues("broker")) {
      setStatus("fetched-person-details");
    }
  }, []);

  return (
    <div>
      <Grid columns={["auto", "repeat(2, 1fr)"]} gap={[".5rem", "1rem"]}>
        <Forms.InputGroup
          name="responsible.cpf"
          label="CPF"
          placeholder="Digite o CPF"
          mask="cpf"
          loading={status === "fetching-person-details"}
          onKeyUp={(event) => {
            setDocument(event.target.value);
          }}
        />
      </Grid>

      {status === "fetched-person-details" && (
        <Grid
          gap={[".5rem", "1rem"]}
          space={[".5rem 0 0", "1rem 0 0"]}
          columns={["auto", "repeat(2, 1fr)"]}
        >
          <Forms.InputGroup
            name="responsible.name"
            label="Nome"
            placeholder="Digite o nome"
          />

          <Forms.InputGroup
            name="responsible.phone"
            label="Telefone/celular"
            placeholder="Digite o telefone/celular"
            mask="phone"
          />

          <Forms.InputGroup
            name="responsible.email"
            label="E-mail pessoal"
            placeholder="Digite o e-mail pessoal"
            tip="Insira um e-mail pessoal do corretor para contato, envio e assinatura eletrônica do contrato de estipulação."
          />
        </Grid>
      )}
    </div>
  );
};
